import { EnumItem } from '@core/models/enum-item.model';
import { CurrencyRateOperationEnum } from '@enums/CurrencyRateOperation';

export const CurrencyRateOperationEnumItems: EnumItem<CurrencyRateOperationEnum>[] = [
  {
    key: CurrencyRateOperationEnum.Division,
    titleKey: `CURRENCY_OPERATION.${CurrencyRateOperationEnum.Division.toUpperCase()}`
  },

  {
    key: CurrencyRateOperationEnum.Multiplication,
    titleKey: `CURRENCY_OPERATION.${CurrencyRateOperationEnum.Multiplication.toUpperCase()}`
  }
];
